"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoursesContextProvider = exports.CoursesContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var defaults_1 = require("./defaults");
var states_1 = require("./states");
var useLocalStorage_1 = require("../hooks/useLocalStorage");
var index_1 = require("./index");
var courses_1 = require("./../../services/courses");
exports.CoursesContext = (0, react_1.createContext)({
    courses: defaults_1.defaultConfig.courses,
    fetchCourses: defaults_1.defaultConfig.fetchCourses,
});
var CoursesContextProvider = function (_a) {
    var children = _a.children, defaults = _a.defaults, apiUrl = _a.apiUrl;
    var abortControllers = (0, react_1.useRef)({});
    (0, react_1.useEffect)(function () {
        var _a;
        if (defaults) {
            defaults.courses !== null &&
                setCourses({
                    loading: false,
                    list: (_a = defaults.courses) === null || _a === void 0 ? void 0 : _a.list,
                    error: undefined,
                });
        }
    }, [defaults]);
    var _b = (0, useLocalStorage_1.useLocalStorage)("lms", "courses", (0, index_1.getDefaultData)("courses", __assign(__assign({}, defaults_1.defaultConfig), defaults))), courses = _b[0], setCourses = _b[1];
    var fetchCourses = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "courses/".concat(JSON.stringify(filter)),
            mode: "paginated",
            fetchAction: courses_1.course.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["courses/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setCourses,
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.CoursesContext.Provider, __assign({ value: {
            courses: courses,
            fetchCourses: fetchCourses,
        } }, { children: children })));
};
exports.CoursesContextProvider = CoursesContextProvider;
